interface LiveUriPreviewProps {
  uri: string
  label?: string
}

export function LiveUriPreview({ uri, label = "Resource URI Preview" }: LiveUriPreviewProps) {
  return (
    <div className="space-y-1.5">
      <p className="text-sm font-medium text-muted-foreground">{label}</p>
      <div className="rounded-md border bg-muted/50 px-3 py-2">
        <code className="text-sm font-mono break-all text-foreground">
          {uri || <span className="text-muted-foreground italic">Fill in the fields above to preview the URI</span>}
        </code>
      </div>
    </div>
  )
}
